import clsx from 'clsx';

import { BaseCfAssetComponent, IconStyle } from '../types';

export enum CfImageType {
  Icon = 'Icon',
  Image = 'Image'
}

export interface CfImageProps extends BaseCfAssetComponent {
  fields: {
    description?: string;
    file: {
      contentType: string;
      details: {
        image: {
          height: number;
          width: number;
        };
        size: number
      }
      fileName: string;
      url: string;
    }
    title: string;
  }
  className?: string;
  containerClassName?: string;
  disableDefaultClassName?: boolean;
  iconStyle?: IconStyle;
  type?: CfImageType;
}

const getImageClassNames = ({ iconStyle, type }: Pick<CfImageProps, 'iconStyle' | 'type'>) => {
  if (type === CfImageType.Icon) {
    const className = 'object-cover overflow-hidden box-content aspect-square';

    if (iconStyle === IconStyle.Default || iconStyle === IconStyle.App) {
      return clsx(className, 'lg:h-6 lg:w-6 h-5 w-5');
    }

    return 'object-cover overflow-hidden lg:h-12 lg:w-12 h-10 w-10 box-content aspect-square';
  }

  return null;
};

const getContainerClassNames = ({ iconStyle, type }: Pick<CfImageProps, 'iconStyle' | 'type'>) => {
  if (type === CfImageType.Icon) {
    if (iconStyle === IconStyle.Default) {
      return 'bg-surface-l2 can-hover:group-hover:bg-surface-l2-active rounded-md p-3 w-fit';
    }

    if (iconStyle === IconStyle.App) {
      return 'bg-transparent rounded-md p-3 w-fit';
    }
  }

  return null;
};

const CfImage = ({
  className,
  containerClassName,
  disableDefaultClassName = false,
  fields,
  iconStyle = IconStyle.Default,
  type = CfImageType.Image,
}: CfImageProps) => {
  const {
    description, file: { details: { image }, url }, title,
  } = fields;

  return (
    <span
      className={clsx(
        !disableDefaultClassName && getContainerClassNames({
          iconStyle,
          type,
        }),
        containerClassName
      )}
    >
      <img
        alt={description || title}
        className={clsx(
          !disableDefaultClassName && getImageClassNames({
            iconStyle,
            type,
          }),
          className
        )}
        src={url}
        title={title}
        {...image}
      />
    </span>
  );
};

export default CfImage;
